import { CachedImage, DotMenu } from '@shared/ui';
import type { Banner } from '../../types';
import './BannerCard.css';

interface BannerCardProps {
  banner: Banner;
  onOpenStories: (banner: Banner) => void;
  onEdit?: (banner: Banner) => void;
  onDelete?: (banner: Banner) => void;
  onToggleActive?: (banner: Banner) => void;
}

export default function BannerCard({
  banner,
  onOpenStories,
  onEdit,
  onDelete,
  onToggleActive,
}: BannerCardProps) {
  const menuItems = [
    ...(onEdit ? [{
      label: 'Редактировать',
      onClick: () => onEdit(banner),
    }] : []),
    ...(onToggleActive ? [{
      label: banner.isActive ? 'Скрыть' : 'Показать',
      onClick: () => onToggleActive(banner),
    }] : []),
    ...(onDelete ? [{
      label: 'Удалить',
      onClick: () => onDelete(banner),
      isDanger: true,
    }] : []),
  ];

  return (
    <div className="banner-card-wrapper">
      <div className="banner-card" onClick={() => onOpenStories(banner)}>
        <div className={`banner-card-image ${!banner.isActive ? 'banner-card-image-hidden' : ''}`}>
          <CachedImage
            src={banner.imageUrl}
            alt={banner.title || `Баннер ${banner.id}`}
          />
        </div>
        {banner.title && (
          <div className="banner-card-content">
            <h3 className="banner-card-title">{banner.title}</h3>
          </div>
        )}
        {!banner.isActive && (
          <div className="banner-card-inactive-badge">Скрыт</div>
        )}
      </div>
      {menuItems.length > 0 && (
        <div className="banner-card-menu" onClick={(e) => e.stopPropagation()}>
          <DotMenu items={menuItems} />
        </div>
      )}
    </div>
  );
}

